/***
 * @file:
 * @author: caojianping
 * @Date: 2021-03-11 15:08:43
 */
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService } from '@ithinkdt/shared/browser';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { API, ChangeAccountService, LogoutService } from '@ithinkdt/theme/fetch-service';
import { AccountInfo } from '@ithinkdt/theme/models';

import { DEFAULT_USER_AVATAR } from './default-user-avatar';

export type PlacementType = 'right' | 'left';

@Component({
  selector: 'dt-pcp-theme-user-panel',
  templateUrl: './pcp-theme-user-panel.component.html',
  styleUrls: ['./pcp-theme-user-panel.component.scss'],
})
export class PcpThemeUserPanelComponent implements OnInit, OnChanges, OnDestroy {
  @Input() visible = false;
  @Input() placement: PlacementType = 'right';
  @Input() top = 48;
  @Input() fullName = '';
  @Input() firstName = '';

  @Output() close = new EventEmitter();

  accountVisible = false;
  accounts: AccountInfo[] = [];
  currentAccount: string;

  constructor(
    private router: Router,
    private settingSrv: SettingsService,
    private logoutService: LogoutService,
    private changeAccountSrv: ChangeAccountService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const visibleChanges = changes['visible'];
    if (visibleChanges && visibleChanges.currentValue) {
      this.getAccounts();
    }
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  // è·åç§æ·åè¡¨
  getAccounts() {
    this.changeAccountSrv.getAccountList().subscribe((res: any) => {
      if (res.status) {
        const data = res.data || [];
        data.map((item: AccountInfo) => {
          item.logo = item.logo
            ? `${this.settingSrv.userConfig.env.serverName.file}${API.downloadImageByPubUrl}${item.logo}`
            : DEFAULT_USER_AVATAR;

          if (item.selected) {
            this.currentAccount = item.tenantName;
          }
        });
        this.accounts = data;
      }
    });
  }

  // æå¼è´¦æ·æ¨¡ææ¡
  openAccount() {
    this.close.emit();
    this.accountVisible = true;
  }

  // å¤çè´¦æ·æ¨¡ææ¡å³é­äºä»¶
  onAccountClose() {
    this.accountVisible = false;
  }

  // å¤çè´¦æ·æ¨¡ææ¡æ¹åäºä»¶
  onAccountChange(accounts: AccountInfo[]) {
    this.accounts = accounts;
  }

  // å¤çè´¦æ·æ¨¡ææ¡æ´æ°äºä»¶
  onAccountRefresh() {
    this.getAccounts();
  }

  // æ³¨é
  logout() {
    this.logoutService.logout().subscribe((res) => {
      this.settingSrv.resetSettings();
      this.router.navigateByUrl(COMMON_COMFIG.LOGIN_URL);
    });
  }
}
